__turbopack_context__.v({
  "close-panel": "Modal-module-scss-module__MO_n4a__close-panel",
  "modal": "Modal-module-scss-module__MO_n4a__modal",
  "modal-body": "Modal-module-scss-module__MO_n4a__modal-body",
  "modal-content": "Modal-module-scss-module__MO_n4a__modal-content",
});
